// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "An interactive that provides audio playback for a given clip, as well as quotation text for multiple subjects.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Audio embed",
  id: "audio-quotes",
  linkPrefix: "/interactives",
  tags: ["Audio", "Quotes", "Configurable"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/audio-enhanced-hub/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import("app/components/tools/AudioQuotesConfigTool/AudioQuotesConfigTool"),
    loading: DynamicImportLoader,
    modules: ["AudioQuotesConfigTool"]
  })
};

export default CONFIG;
